export default "__VITE_ASSET__BxmXC01o__"